import { r } from 'config/routes'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { createPanelRoute } from 'views/panel/PanelLayout'

const LoginHistoryList = lazy(() => import('../List'))

export const loginHistoryRoutes: RouteObject[] = [
  createPanelRoute({
    path: r['loginHistory.list'],
    element: <LoginHistoryList />,
  }),
]
